// extracted by mini-css-extract-plugin
export default {"description":"ListItem_description__NW+vz","li":"ListItem_li__4PDXu","clickable":"ListItem_clickable__brlDy"};